import { GroupTypes } from "@/types";
import { request } from "./request";

/**
 * Search Group List
 * @param payload Search parameters for group
 * @param authToken Authorization token header to be added to make the call
 * @returns The list of groups filtered by the optionally specified filter.
 */
export async function getGroupList(
  data: GroupTypes.GroupListPayload,
  authToken: string,
): Promise<GroupTypes.GroupListResponse> {
  const response = await request<GroupTypes.GroupListResponse>(
    {
      url: "/group/list",
      method: "POST",
      data,
    },
    authToken,
  );

  return response;
}
